module.exports = __webpack_public_path__ + "img/1f9ab.64399f9.svg";